<div class="auth">
    <div class="auth__header">
        <div class="auth__logo">
            @if (!router.url.includes('control') && (configurationServer$ | async)?.serverName) {
                <svg-icon [class.auth__logo--ccc]="(configurationServer$ | async)?.serverName === serverNamesEnum.CCC"
                          [src]="(configurationServer$ | async)?.serverName === serverNamesEnum.SC ? LOGO_USER_ICON_PATH : LOGO_USER_CCC_ICON_PATH"></svg-icon>
            } @else {
                <svg-icon
                    [class.auth__logo-admin--ccc]="(configurationServer$ | async)?.serverName === serverNamesEnum.CCC"
                    [src]="(configurationServer$ | async)?.serverName === serverNamesEnum.SC ? LOGO_ADMIN_ICON_PATH : LOGO_ADMIN_CCC_PATH"></svg-icon>
            }
        </div>
        <div class="auth__ln">
            <app-lang></app-lang>
        </div>
    </div>

    <div class="auth__wrapper">

        <router-outlet></router-outlet>

    </div>
</div>

